export enum NetworkInfoType {
  NoNetwork = 1,
  FirewallBlocked,
  PortsBlocked,
  ClientError,
  ServerError,
  NoInternet
}

export interface NetworkInfoRequest {
  id?: number;
  type: NetworkInfoType;
  districtId: string;
  schoolId: string;
  classId: string;
  userId: string;
  username: string;
  startTime: string;
  endTime: string;
  networkStatus: boolean;
  additionalInfo: string;
  userFullName: string;
  deviceType: string;
  userAgent: string;
  lightSailVersion: string;
}
